import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '../../components/layout/layout';

export default function MentionsLegalesPage() {
  return (
    <Layout>
      <Helmet>
        <title>Mentions légales | recruteurs.io</title>
        <meta
          name="description"
          content="Mentions légales du site recruteurs.io : éditeur, responsable de publication, hébergeur, propriété intellectuelle et contact."
        />
        <link rel="canonical" href="https://recruteurs.io/legal/mentions-legales/" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="container-custom max-w-3xl py-16">
        <h1 className="text-4xl font-bold mb-10 text-neutral-900">Mentions légales</h1>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">1. Éditeur du site</h2>
          <p className="text-neutral-600 leading-relaxed">
            Le site <strong>recruteurs.io</strong> est édité par :<br />
            <strong>LOOCATME</strong><br />
            Forme juridique : Société par actions simplifiée unipersonnelle (SASU)<br />
            Capital social : 1 000 €<br />
            Siège social : 11 chemin du Mont Gibaou, 13260 Cassis, France<br />
            SIREN : 832 172 506<br />
            RCS : Marseille 832 172 506<br />
            Contact : contact@recruteurs.io
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">2. Directeur de la publication</h2>
          <p className="text-neutral-600 leading-relaxed">
            Le directeur de la publication est :<br />
            Gérald Gaillard, Président de LOOCATME<br />
            Contact : <a href="mailto:contact@recruteurs.io" className="underline hover:text-[#d03484]">contact@recruteurs.io</a>
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">3. Hébergeur</h2>
          <p className="text-neutral-600 leading-relaxed">
            Le site est hébergé par :<br />
            <strong>Netlify, Inc.</strong><br />
            512 2nd Street, Suite 200, San Francisco, CA 94107, États-Unis<br />
            Contact : https://www.netlify.com
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">4. Propriété intellectuelle</h2>
          <p className="text-neutral-600 leading-relaxed">
            L'ensemble des contenus présents sur le site recruteurs.io (textes, images, logos, vidéos, graphismes, etc.)
            sont protégés par le droit d'auteur et appartiennent à LOOCATME ou à leurs auteurs respectifs.
            Toute reproduction, représentation, modification, publication ou transmission, totale ou partielle,
            du contenu du site est interdite sans autorisation écrite préalable.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">5. Liens hypertextes</h2>
          <p className="text-neutral-600 leading-relaxed">
            Le site peut contenir des liens vers des sites tiers. recruteurs.io n'exerce aucun contrôle sur ces
            sites et décline toute responsabilité quant à leur contenu, leurs pratiques de confidentialité ou
            leur disponibilité.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">6. Limitation de responsabilité</h2>
          <p className="text-neutral-600 leading-relaxed">
            recruteurs.io s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur le site.
            Toutefois, recruteurs.io ne peut garantir l'exactitude, la complétude ou l'actualité des informations
            publiées. L'utilisateur utilise le site sous sa propre responsabilité.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-xl font-semibold text-neutral-800 mb-3">7. Contact</h2>
          <p className="text-neutral-600 leading-relaxed">
            Pour toute question relative au site :<br />
            E-mail : <a href="mailto:contact@recruteurs.io" className="underline hover:text-[#d03484]">contact@recruteurs.io</a><br />
            Site : https://recruteurs.io<br />
            Adresse postale : 11 chemin du Mont Gibaou, 13260 Cassis, France
          </p>
        </section>

        <p className="text-sm text-neutral-400 mt-12">Dernière mise à jour : juillet 2026</p>
      </div>
    </Layout>
  );
}
